import { defaultAxios, IParams } from '../base';

export interface IFetchHouseCertCheck extends IParams {
  // todo parameter 추가 예정
}

// 주담대 본인 인증 완료 체크
export const fetchHouseCertCheck = async (params: IFetchHouseCertCheck) => {
  return await defaultAxios().post(`/house/certCheck`, params);
};
